import { Moon, Sun } from 'lucide-react';
import { usePortalTheme } from './PortalThemeContext';

/** Compact light/dark switch for the portal header. */
export const PortalThemeToggle = () => {
  const { theme, toggleTheme } = usePortalTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="portal-theme-toggle"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={isDark}
      data-testid="portal-theme-toggle"
    >
      <span className="portal-theme-toggle-icon" data-testid={isDark ? 'portal-theme-icon-moon' : 'portal-theme-icon-sun'}>
        {isDark ? <Moon size={17} aria-hidden="true" /> : <Sun size={17} aria-hidden="true" />}
      </span>
    </button>
  );
};
